export const PANDA_REFACTOR_EXPERIMENT_NAME = 'card_5990_css_framework_refactor';
export const PANDA_REFACTOR_EXPERIMENT_SLUGS = ['bonus-offers'];

export const PANDA_REFACTOR_ROUTE_PREFIXES = [
  { source: '/credit-cards/best', target: '/credit-cards/best/panda' },
  { source: '/credit-cards/m/best', target: '/credit-cards/m/best/panda' },
] as const;
